import React from 'react';

import { useFetchPluginById } from '../../../hooks';
import { VpHookFormSelect, VpConditionalUpgradeWrapper } from '../..';
import { PLUGIN_MANAGEMENT_ENABLED } from '../../../constants/feature-keys';

const options = [
  { id: 'NEWEST', label: 'Newest to Oldest' },
  { id: 'OLDEST', label: 'Oldest to Newest' },
  { id: 'RANDOM', label: 'Random' }
];

export const VpPluginSortingSelect = () => {
  const { data } = useFetchPluginById();
  const defaultValue = data?.sortOrder;

  return (
    <VpConditionalUpgradeWrapper fullWidth featureKey={PLUGIN_MANAGEMENT_ENABLED}>
      {({ isDisabled }) => (
        <VpHookFormSelect
          smallLabel
          label="SORTING"
          defaultValue={defaultValue}
          options={options}
          name="sortOrder"
          disableHelperText
          disabled={isDisabled}
          selectDefault
        />
      )}
    </VpConditionalUpgradeWrapper>
  );
};

export default VpPluginSortingSelect;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/plugin-details/VpPluginSortingSelect.jsx